import { ResourceService } from '@socialbrothers/services';

import { ApiService } from '@Services/index';

import { ILog } from './LogService.props';

export class LogServiceImplementation extends ResourceService<ILog> {}

export const LogService = new LogServiceImplementation(ApiService, '/admin/logs');
